var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-foot"},[(_vm.language==='cn')?[_c('p',[_vm._v("Copyright（C）2024第三届国际农业生物多样性大会 版权所有")])]:[_c('p',[_vm._v("Copyright (C) 2024 The Third International Agrobiodiversity Congress. All rights reserved")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }